module.exports = __webpack_public_path__ + "static/media/Fabrika-zabave-roll-up.3af8d225.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fabrika-zabave/Fabrika-zabave-roll-up.jpg
// module id = 412
// module chunks = 0